import {
    Fragment,
    type Inline,
    NODE_MISSING_FRAGMENT,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import {
    BLOCK_CODE_LINE,
    FRAGMENT_ANNOTATION_BODY,
    INLINE_ANNOTATION,
    LEAF_RICH_BLOCKS,
} from '../types';
import { FRAGMENT_ALLOWED_BLOCKS } from '../utils';

export const schema = Schema.create({
    inlines: {
        [INLINE_ANNOTATION]: {
            parent: {
                types: [...LEAF_RICH_BLOCKS, BLOCK_CODE_LINE],
            },
            nodes: [{ objects: ['text'] }],
            fragments: {
                nodes: [{ objects: ['block'] }],
                keys: {
                    [FRAGMENT_ANNOTATION_BODY]: FRAGMENT_ANNOTATION_BODY,
                },
                types: {
                    [FRAGMENT_ANNOTATION_BODY]: {
                        min: 1,
                        max: 1,
                        nodes: [
                            {
                                objects: ['block'],
                                types: FRAGMENT_ALLOWED_BLOCKS[FRAGMENT_ANNOTATION_BODY],
                                min: 1,
                            },
                        ],
                    },
                },
            },
            normalize: Schema.createNormalize<Inline>({
                [NODE_MISSING_FRAGMENT]: (change, context) => {
                    // @ts-expect-error
                    const { node, key } = context;

                    if (key === FRAGMENT_ANNOTATION_BODY) {
                        return change.setFragmentByKey(
                            node.key,
                            Fragment.create({
                                fragment: FRAGMENT_ANNOTATION_BODY,
                                type: FRAGMENT_ANNOTATION_BODY,
                                nodes: [createParagraph()],
                            })
                        );
                    }
                },
                [PARENT_TYPE_INVALID]: (change, context) => {
                    const { node, parent } = context;

                    if (parent.object === 'inline') {
                        change.unwrapNodeByKey(node.key);
                    } else {
                        change.removeNodeByKey(node.key);
                    }
                },
            }),
        },
    },
});
